import { $api } from '@/shared/api/axiosInstance';

export type QueryFilter = {
    goalMeters: number;
    goalRooms: number;
    userId: string;
};

export const updateGoal = async ({ userId, goalMeters, goalRooms }: QueryFilter) => {
    const url = `/api/v1/users/${userId}/goals`;

    const { data } = await $api.put(url, { goalMeters, goalRooms });

    return data;
};
